import { ShieldCheck, BadgePercent, HandHeart, Clock4 } from "lucide-react";
import { BrandMark } from "@/components/site/BrandMark";

const points = [
  {
    icon: BadgePercent,
    title: "Honest, Below-Industry Rates",
    desc: "Our quotes consistently come in below typical Singapore renovation firms — without skipping on materials or finishing quality.",
  },
  {
    icon: ShieldCheck,
    title: "One Project Lead, Start to End",
    desc: "You'll never be passed around. The same person who quotes your home walks every site visit until handover.",
  },
  {
    icon: HandHeart,
    title: "Family-First Philosophy",
    desc: "We renovate the way we'd want for Noah and Rayn — quiet care over loud sales, finishing over flash.",
  },
  {
    icon: Clock4,
    title: "On-Time, Clean Handovers",
    desc: "Detailed milestones, daily progress photos, and the kind of dust protocols that make moving day actually feel like moving day.",
  },
];

export const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[color:var(--nr-ink)] text-[color:var(--nr-bg)] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 reveal">
          <div className="lg:col-span-6">
            <BrandMark className="w-10 h-10 text-[#E6A079] mb-5" data-testid="why-brandmark" />
            <p className="overline mb-5" style={{ color: "#E6A079" }}>
              Why Noah+Rayn
            </p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
              The kind of authority that{" "}
              <em className="italic font-light" style={{ color: "#E6A079" }}>
                doesn't need to shout.
              </em>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-white/75 leading-relaxed text-base lg:text-lg">
              Built on trust handed down from past clients, refined by an
              artist's eye for atmosphere, and delivered at a price that respects
              the cost of starting a family home.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {points.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={i}
                data-testid={`why-point-${i}`}
                className="reveal bg-[color:var(--nr-ink)] p-9 lg:p-12 flex flex-col gap-5 hover:bg-[#3a2e2b] transition-colors duration-500"
              >
                <div className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center">
                  <Icon size={20} className="text-[color:var(--nr-accent)]" />
                </div>
                <h3 className="font-serif-display text-2xl lg:text-3xl">
                  {p.title}
                </h3>
                <p className="text-white/70 leading-relaxed text-sm lg:text-base">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
